import { AnalogInput, Command, HeatingCircuit, IntervalTimetable, IOExtension, Notification, RelayControl, TimeInterval, User, } from 'z3k-config';
import { analogInputESP, consumer_timeinterval, hc_boiler, hc_consumer, hm_comfort, hm_eco, hm_off, hm_schedule, io_extension, notification_conn_lost, notification_find_power, notification_lost_power, notification_low_balance, relayESP, timetable_consumer, user20533, } from 'features/settings-master/model/default/objects';
import { boiler_with_reserve_ti_id, boiler_with_reserve_timetable_id, command_off_id, command_on_id, dhw_ti_id, dhw_timetable_id, hc_dhw_id, hc_reserve_id, hm_reserve_id, hm_summer_id, notifications_boiler_error_id, reserve_boiler_ti_id, reserve_boiler_timetable_id, } from 'features/settings-master/model/default/ids';
import { findAndChangeLinks } from 'z3k-parser/lib/find-links';
import { removeNulls } from 'utils';
import { HeatingMode } from 'z3k-parser/model/z3k-config/20-heating-mode';
const mutable_objects = () => {
    return removeNulls([
        [User, user20533],
        [RelayControl, relayESP],
        [HeatingCircuit, hc_boiler],
        [HeatingCircuit, hc_consumer],
        [IntervalTimetable, timetable_consumer],
        [TimeInterval, consumer_timeinterval],
        [Notification, notification_low_balance],
        [Notification, notification_lost_power],
        [Notification, notification_find_power],
        [Notification, notification_conn_lost],
        [HeatingMode, hm_comfort],
        [HeatingMode, hm_eco],
        [HeatingMode, hm_schedule],
        [HeatingMode, hm_off],
        [AnalogInput, analogInputESP],
        [IOExtension, io_extension],
    ]);
};
export const findOrCreateBaseObjects = (config) => mutable_objects().reduce((new_config, [objNS, obj]) => objNS.get.createIfNotExists(new_config, obj), config);
//можем удалять!
const auto_generate_objects = [
    [Command, command_on_id],
    [Command, command_off_id],
    [HeatingCircuit, hc_dhw_id],
    [IntervalTimetable, dhw_timetable_id],
    [TimeInterval, dhw_ti_id],
    [HeatingCircuit, hc_reserve_id],
    [HeatingMode, hm_reserve_id],
    [IntervalTimetable, boiler_with_reserve_timetable_id],
    [TimeInterval, boiler_with_reserve_ti_id],
    [IntervalTimetable, reserve_boiler_timetable_id],
    [TimeInterval, reserve_boiler_ti_id],
    [Notification, notifications_boiler_error_id],
    [HeatingMode, hm_summer_id],
];
export const findAndRemoveMutableObjects = (config) => auto_generate_objects.reduce((config, [objNS, objId]) => findAndChangeLinks(objNS.get.removeById(config, objId), objId), config);
